export { default as subcompaniesReducers } from 'subcompanies/reducers/subcompanies_reducers';



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/reducers/index.js